module.exports = __webpack_public_path__ + "img/mark-lewandowski.df330d9e.jpg";